module.exports = __webpack_public_path__ + "static/img/15wokankan.2f1c19c1.gif";